export const config = {"prefix":"tw-","content":[],"darkMode":"class"};